/**
 * @author Andrew Kim
 * @version 3.0.0
 * @since 26 March 2025
 */


import React from "react";


const page404: React.FC = () => (
    <></>
);


export default page404;
